// extracted by mini-css-extract-plugin
module.exports = {"color":"color 0.3s ease","backgroundColor":"background-color 0.2s ease","borderColor":"border-color 0.3s ease","opacity":"opacity 0.3s ease"};